import { render } from "./collection-grid.vue?vue&type=template&id=23058f6d"
import script from "./collection-grid.vue?vue&type=script&lang=js"
export * from "./collection-grid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__